import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileSaverService } from 'ngx-filesaver';

@Injectable()
export class ReportService {
  constructor(
    private httpClient: HttpClient,
    private fileSaver: FileSaverService,
  ) {}

  downloadReport(url: string, fileName: string) {
    const contentType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    this.httpClient.get(url, { responseType: 'blob' }).subscribe((response) => {
      const data = response;
      const blob = new Blob([data as BlobPart], { type: contentType });
      this.fileSaver.save(blob, fileName);
    });
  }
}
